module.exports = __webpack_public_path__ + "img/login2x.fa4705c4.png";